// extracted by mini-css-extract-plugin
export default {"wrapper":"eD-z","addressLine":"fD-z","fullName":"gD-z"};